function isVideo(videoPath) {
  return /^.*\.(|mov|MOV|mp4|MP4)$/.test(videoPath);
}

module.exports = {
  isVideo,
};
